'use strict';

exports.__esModule = true;
exports.default = typeof Map !== 'undefined' ? Map : require('core-js/library/es6/map');